import { FaChartLine, FaCheckCircle, FaHourglassHalf, FaPhone, FaRobot } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import styles from "./SalesPersonInfo.module.css";

const SalesPersonInfo = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      {/* Top Agent Info */}
      <div className={styles.agentCard}>
        <div className={styles.agentDetails}>
          <div className={styles.iconBox}>
            <FaRobot size={28} />
          </div>
          <div>
            <div className={styles.label}>Agent Name</div>
            <div className={styles.value}>Luxury Flats Assistant</div>
            <div className={styles.label}>Agent Type</div>
            <span className={styles.voiceBadge}>VOICE</span>
          </div>
        </div>

        <div className={styles.metaInfo}>
          <div>
            <div className={styles.label}>Created On</div>
            <div className={styles.value}>July 20, 2024</div>
          </div>
          <div>
            <div className={styles.label}>Created By</div>
            <div className={styles.value}>John Doe</div>
          </div>
          <div>
            <div className={styles.label}>Campaign</div>
            <div className={styles.value}>Luxury Villas – Pune</div>
          </div>
          <div>
            <div className={styles.label}>Status</div>
            <span className={styles.statusBadge}>ACTIVE</span>
          </div>
        </div>
      </div>

      {/* Performance Metrics */}
      <h3 className={styles.metricHeading}>Performance Metrics</h3>
      <div className={styles.metricsGrid}>
        <div className={styles.metricCard}>
          <FaPhone className={styles.metricIcon} />
          <div className={styles.metricValue}>120</div>
          <div className={styles.metricLabel}>Calls Made <span className={styles.positive}>↑ 5%</span></div>
        </div>
        <div className={styles.metricCard}>
          <FaCheckCircle className={styles.metricIcon} />
          <div className={styles.metricValue}>60</div>
          <div className={styles.metricLabel}>Connected Calls <span className={styles.positive}>↑ 2%</span></div>
        </div>
        <div className={styles.metricCard}>
          <FaChartLine className={styles.metricIcon} />
          <div className={styles.metricValue}>8</div>
          <div className={styles.metricLabel}>Leads Converted <span className={styles.positive}>↑ 1%</span></div>
        </div>
        <div className={styles.metricCard}>
          <FaHourglassHalf className={styles.metricIcon} />
          <div className={styles.metricValue}>2m 45s</div>
          <div className={styles.metricLabel}>Avg. Call Duration <span className={styles.negative}>↓ 3%</span></div>
        </div>
      </div>

<h3 className={styles.metricHeading}>Call Interaction Table</h3>
<div className={styles.tableWrapper}>
  <table className={styles.interactionTable}>
    <thead>
      <tr>
        <th>LEAD</th>
        <th>CALL DATE</th>
        <th>STATUS</th>
        <th>NOTES</th>
        <th>ACTION</th>
      </tr>
    </thead>
    <tbody>
      {[
        {
          lead: "Riya Shah",
          date: "24 Jul",
          status: "Connected",
          note: "Interested in 2BHK",
          icons: true,
        },
        {
          lead: "Kunal M.",
          date: "24 Jul",
          status: "Missed",
          note: "—",
          icons: false,
        },
        {
          lead: "Asha T.",
          date: "23 Jul",
          status: "Follow-Up",
          note: "Call next week",
          icons: true,
        },
        {
          lead: "Priya S.",
          date: "23 Jul",
          status: "Connected",
          note: "Sent brochure",
          icons: false,
        },
        {
          lead: "Rahul K.",
          date: "22 Jul",
          status: "Missed",
          note: "No answer",
          icons: false,
        },
        {
          lead: "Sneha D.",
          date: "22 Jul",
          status: "Follow-Up",
          note: "Requested callback",
          icons: false,
        },
      ].map((item, idx) => (
        <tr key={idx}>
          <td>{item.lead}</td>
          <td>{item.date}</td>
          <td>
            <span className={`${styles.status} ${styles[item.status.toLowerCase().replace("-", "")]}`}>
              {item.status.toUpperCase()}
            </span>
          </td>
          <td>{item.note}</td>
          <td className={styles.actionIcons}>
            {item.icons && <span className={styles.playIcon}>▶️</span>}
            <span className={styles.infoIcon}>ℹ️</span>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

{/* Agent Script Section */}
<h3 className={styles.metricHeading}>Agent Script</h3>
<div className={styles.scriptCard}>
  <div className={styles.scriptHeader}>
    <strong>Initial Contact Script – Luxury Flats</strong>
  </div>
  <p className={styles.scriptText}>
    "Hello, my name is [Agent Name] from [Company Name]. I'm calling regarding your interest in luxury flats in Pune. We have some exclusive properties that might be a perfect fit for you..."
  </p>
  <p className={styles.editedText}>
    Last edited on: July 18, 2024 by John Doe
  </p>
  <button onClick={() => navigate("/AgentScriptFull")} className={styles.viewScriptBtn}>
  View Full Script
</button>
</div>

{/* Performance Charts & Insights */}
<h3 className={styles.metricHeading}>Performance Charts & Insights</h3>
<div className={styles.chartsGrid}>
  <div className={styles.chartCard}>
    <div className={styles.chartTitle}>Daily Calls Trend</div>
    <div className={styles.chartPlaceholder}></div>
  </div>
  <div className={styles.chartCard}>
    <div className={styles.chartTitle}>Lead Conversion Rate</div>
    <div className={styles.chartPlaceholder}></div>
  </div>
  <div className={styles.chartCard}>
    <div className={styles.chartTitle}>Call Outcome Distribution</div>
    <div className={styles.chartPlaceholder}></div>
  </div>
</div>



    </div>
  );
};

export default SalesPersonInfo;
